import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询
export function query(data) {
  return request({
    url: URL.mdm.internalFeeMarkupRule.queryUrl,
    method: 'post',
    data
  })
}

// 新增
export function add(data) {
  return request({
    url: URL.mdm.internalFeeMarkupRule.addUrl,
    method: 'post',
    data
  })
}

// 编辑
export function edit(data) {
  return request({
    url: URL.mdm.internalFeeMarkupRule.editUrl,
    method: 'post',
    data
  })
}

// 启用/停用
export function setEnabled(data) {
  return request({
    url: URL.mdm.internalFeeMarkupRule.setEnabledUrl,
    method: 'post',
    data
  })
}

// 批量删除
export function batchDelete(data) {
  return request({
    url: URL.mdm.internalFeeMarkupRule.batchDeleteUrl,
    method: 'post',
    data
  })
}
